import React from 'react';
import {SidebarMenuItem} from '@/_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuItem';

const AnalyticsMenu = () => {
  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Analytics</span>
        </div>
      </div>

      <SidebarMenuItem
        to='/analytics/overview'
        title='Dashboard'
        icon='chart-line'
      />

      <SidebarMenuItem
        to='/analytics/reports'
        title='Reports'
        icon='chart-line-star'
      />

      <SidebarMenuItem
        to='/analytics/devices'
        title='Devices'
        icon='monitor-mobile'
      />

      <SidebarMenuItem
        to='/analytics/pages-report'
        title='Pages'
        icon='some-files'
      />
    </>
  );
}

export default AnalyticsMenu;
